"use strict";
/**
 * Created on 05 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ExportedEntity_1 = require("../../export/model/ExportedEntity");

var ExportedEntityState_1 = require("../../export/model/ExportedEntityState");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * <p>Record of export queue related to export {@link ProductSensitivity sensitivities} and their association to {@link Product}. Record
 * is without association to an entity, each and every export is FULL export. Export has two exporting tables. One table is for taxonomies
 * of product sensitivities ({@link ProductSensitivity}), the other one is for binding of product sensitivity and products.</p>
 *
 * @author JMe
 */


var ProductSensitivityExportQueueRecord =
/*#__PURE__*/
function (_ExportedEntity_1$Exp) {
  _inherits(ProductSensitivityExportQueueRecord, _ExportedEntity_1$Exp);

  /**
   * Ctor.
   *
   * @param id Identifier of record in the queue.
   * @param state State of export. {@link ExportedEntityState.Success} is final state in case of successful export, failed export
   *        represents {@link ExportedEntityState.Failed} or {@link ExportedEntityState.Closed} with filled {@link ExportedEntity.error}.
   * @param created Time of creation of record.
   * @param createdBy User who created this record.
   * @param lastModified Time of last modification of this record.
   * @param nextAttempt Time of next planned export attempt.
   * @param attemptCount Count of attempts, starts with 0; 1 after first successful of failed attempt.
   * @param requestId Request id returned from IDB.
   * @param error Description of last error if this record is in failed state.
   * @param filePaths Path to exported files with exported prices.
   * @param processId ID of application instance that is responsible for export.
   */
  function ProductSensitivityExportQueueRecord(id, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, filePaths, processId) {
    var _this;

    _classCallCheck(this, ProductSensitivityExportQueueRecord);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityExportQueueRecord).call(this, id, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, processId));
    _this.id = id;
    _this.state = state;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.nextAttempt = nextAttempt;
    _this.attemptCount = attemptCount;
    _this.requestId = requestId;
    _this.error = error;
    _this.filePaths = filePaths;
    _this.processId = processId;
    return _this;
  }

  return ProductSensitivityExportQueueRecord;
}(ExportedEntity_1.ExportedEntity);

exports.ProductSensitivityExportQueueRecord = ProductSensitivityExportQueueRecord;

ProductSensitivityExportQueueRecord.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSensitivityExportQueueRecord.name);
  return {
    id: builder.id('id'),
    state: builder.senum('state', ExportedEntityState_1.ExportedEntityState, 'seq'),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    nextAttempt: builder.date('nextAttempt', DateParser_1.DateParser.ISO_PATTERN),
    attemptCount: builder.num('attemptCount'),
    requestId: builder.opt(builder.num('requestId')),
    error: builder.opt(builder.str('error').withDescription({
      multiline: true
    })),
    filePaths: builder.listOf(builder.str('filePaths')),
    processId: builder.opt(builder.str('processId'))
  };
}();